import { Col } from 'react-bootstrap';
import styled from 'styled-components';

export const DesktopFilter = styled(Col)`
      @media screen and (max-width: 600px) {
            display: none;
      }
`;
